import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const serializeBusinessUnitIds = (businessUnitIds = []) => {
  const ids = Array.isArray(businessUnitIds)
    ? businessUnitIds.map((value) => String(value).trim()).filter(Boolean)
    : [];
  return ids.length ? ids.join(",") : undefined;
};

export const getDashboardStatistics = async (params = {}) => {
  const response = await axios.get(`${BASE_URL}/api/statistics`, {
    params: {
      businessUnitIds: serializeBusinessUnitIds(params.businessUnitIds),
      personType: params.personType || undefined,
      salesId: params.salesId || undefined,
      recruiterId: params.recruiterId || undefined,
      granularity: params.granularity || undefined,
    },
  });

  return response.data;
};
